import { Box, TFText } from '@tf/ui';
import type React from 'react';
import type { PropsWithChildren } from 'react';

export const InfoItem: React.FC<PropsWithChildren<{ label: string }>> = ({ label, children }) => {
	return (
		<Box
			sx={{
				minWidth: '110px',
				maxWidth: '260px',
				fontSize: '14px',
				fontWeight: 500,
			}}
		>
			<TFText
				pb="0.15rem"
				sx={({ colors }) => ({
					color: colors.gray[5],
					fontWeight: 600,
					fontSize: '0.75rem',
					letterSpacing: '.5px',
				})}
			>
				{label}
			</TFText>
			{children}
		</Box>
	);
};

export const InfoItems: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<Box
			sx={({ colors }) => ({
				display: 'flex',

				'& > :not(:first-of-type)': {
					marginLeft: '0.75rem',
					paddingLeft: '0.75rem',
					borderLeft: `1px solid ${colors.gray[3]}`,
				},
			})}
		>
			{children}
		</Box>
	);
};
